

//CONFIGURAÇÕE DO VALIDADOR JQUERY

//Mundando o nome da classe de erro
$(function(){
	$.validator.setDefaults({
		errorClass: 'msg-erro'
	});

});
//FIM
jQuery.validator.addMethod("indicacao", function(value, element) {

	if(value != ''){
		if(value != "HR_AREA17" && value != "JP_AREA17")
		{
			return false;
		}else{
			return true;
		}
	}else{
		return true;
	}
}, "Código de indicação inválido.");

jQuery.validator.addMethod("subcategoria", function(value, element) {
	if(value){
		$('#subcategorias').siblings('.selectize-control').css('border', 'none');
		return true;

	}else{
		$('#subcategorias').siblings('.selectize-control').css('border', '1px solid #D23C48');
		return false;

	}
}, "Selecione pelo menos uma subcategoria");


//Função para notificão de mensagens
function showMessage(type, text)
{
	$.noty.clearQueue();

	var n = noty({
		text        : text,
		type        : type,
		dismissQueue: false,
		layout      : 'topCenter',
		closeWith   : ['click'],
		timeout     : 3000,
		killer  : true,
		theme       : 'relax',
		animation   : {
			open  : 'animated fadeInDown',
			close : 'animated fadeOutUp',
			easing: 'swing',
			speed : 50
		}
	});
}

//Validação e envio do formulário da Home
function errosForm(form)
{
	valid = $("#"+form).valid();

	$("#"+form+" .msg-erro").first().focus();

	if(!valid)
	{
		messageError = "";

		$("#"+form+" label.msg-erro").each(function( index ) {

			if(messageError == "")
			{
				if($(this).html() != "")
				{
					messageError = " - " + $(this).html();
				}

			}
			else
			{
				if($(this).html() != "")
				{

					messageError = messageError + "<br />" + " - " + $(this).html()
				}
			}
		});

		showMessage("error", messageError);
	}
}

function validaNews()
{
    $("#frmNews").validate({
        rules:
        {
			emailNews: { required: true, email: true}
        },
		messages: {
			emailNews: { required: 'Informe o seu email', email: 'E-mail inválido, verifique.'},

		},
		submitHandler: function( form ){
			var dados = $(form).serialize();

			$.ajax({
				type: "POST",
				url: "envia-news.php",
				data: dados,
				success: function( data )
				{
					//Mostra a Msg no topo
					showMessage("success", "E-mail cadastrado com sucesso!");

					//Reseta o Form
					$(form).each (function(){
					  this.reset();
					});

				}
			});
		}
    });
}

//Validação e envio do formulário de Contato
function validaContato()
{
    $("#frmContato").validate({
        rules:
        {
            nome:{required: true},
			email: { required: true, email: true},
			telefone:{required: true},
			assunto:{required: true},
        },
		messages: {
			nome: { required: 'Informe o seu nome' },
			email: { required: 'Informe o seu e-mail', email: 'E-mail inválido, verifique.'},
			telefone:{ required:  'Informe o seu telefone'},
			assunto:{ required:  'Informe o assunto do contato'},
		},
		submitHandler: function( form ){
			var dados = $(form).serialize();

			$.ajax({
				type: "POST",
				url: "envia-contato.php",
				data: dados,
				success: function( data )
				{
					//alert(data);
					//Mostra a Msg no topo
					showMessage("success", "Contato enviado com sucesso!");

					//Reseta o Form
					$(form).each (function(){
					  this.reset();
					});


				}
			});
		}
    });
}

//Validação e envio do formulário de Contato
function validaContatoEmpresa()
{
    $("#frmContatoEmpresa").validate({
        rules:
        {
            ce_nome:{required: true},
			ce_email: { required: true, email: true},
			ce_assunto:{required: true},
        },
		messages: {
			ce_nome: { required: 'Informe o seu nome' },
			ce_email: { required: 'Informe o seu e-mail', email: 'E-mail inválido, verifique.'},
			ce_assunto: { required: 'Informe o assunto da mensagem'},
		},
		submitHandler: function( form ){
			var dados = $(form).serialize();

			$.ajax({
				type: "POST",
				url: "envia-contato-empresa.php",
				data: dados,
				success: function( data )
				{
					//Mostra a Msg no topo
					showMessage("success", "Contato enviado com sucesso!");

					//Reseta o Form
					$(form).each (function(){
					  this.reset();
					});
				}
			});
		}
    });
}

//Validação e envio do formulário de Contato
function validaCadastro()
{
    $("#frmCadastro").validate({
    	ignore: "",
        rules:
        {
            nome:{required: true},
			endereco:{required: true},
			numero:{required: true},
			bairro:{required: true},
			cep:{required: true},
			telefone:{required: true},
			indicacao:{indicacao: true},
			"subcategorias[]":{subcategoria: true},
        },
		messages: {
			nome: { required: 'Informe o nome da empresa' },
			endereco: { required: 'Informe a rua da empresa'},
			numero: { required: 'Informe o numero da empresa'},
			bairro: { required: 'Informe o bairro da empresa'},
			cep: { required: 'Informe o cep da empresa'},
			telefone: { required: 'Informe o telefone da empresa'},
			indicacao: { indicacao: 'Código de indicação inválido'},
			"subcategorias[]": { subcategoria: 'Selecione pelo menos uma subcategoria'},
		},
    });
}

//Validação e envio do formulário de Contato
function validaBusca()
{
    $("#frmBusca").validate({
    	ignore: "",
        rules:
        {
            termo:{required: true},
        },
		messages: {
			termo: { required: 'Informe o que deseja buscar' },
		},
    });
}

//Validação e envio do formulário de Contato
function validaBuscaModal()
{
    $("#frmBuscaModal").validate({
    	ignore: "",
        rules:
        {
            termo:{required: true},
        },
		messages: {
			termo: { required: 'Informe o que deseja buscar' },
		},
    });
}

//Validação e envio do formulário de Contato
function validaAvaliacao()
{
    $("#frmAvaliacao").validate({
    	ignore: "",
        rules:
        {
            score:{required: true},
			title: { required: true},
			comment:{required: true},
        },
		messages: {
			score: { required: 'Informe a nota da sua avaliação' },
			title: { required: 'Informe o título da avaliação'},
			comment: { required: 'Informe a avaliação da empresa'},
		},
		submitHandler: function( form ){
			var dados = $(form).serialize();

			$.ajax({
				type: "POST",
				url: "envia-avaliacao.php",
				data: dados,
				success: function( data )
				{
					//Mostra a Msg no topo
					showMessage("success", "Avaliação enviada com sucesso!");

					//Reseta o Form
					$(form).each (function(){
					  this.reset();
					});

					var inst = $('[data-remodal-id=avaliacao]').remodal();
					inst.close();
				}
			});
		}
    });
}